var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress",style:({
      width: _vm.progress + '%',
      background: 'var(--linear-2-paints,linear-gradient(90deg,rgba(126, 180, 235, 1) 0%,rgba(177, 110, 249, 1) 100%))'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }